import { BaseObject } from "../core/BaseObject";
import { DistanceExtraPayValue } from "./DistanceExtraPayValue";

export class DistanceExtraPay extends BaseObject{
    distanceExtraPayId: number;
    values: DistanceExtraPayValue[] = [];
}